export const EMPTY_EDITOR_VALUE = '<p><br></p>';
export const CUSTOM_ATT_FOR_ANCHOR_IN_RICH_TEXT = 'anchor-in-rich-text';

/* A private class name to prevent quilljs to change HTML */
export const PRIVATE_CLASS_NAME = 'grispi-private-class-name';
export const SIGNATURE_CLASS_NAME = 'grispi-signature-class-name';
